// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Gtt1","inner":"Form_inner__1GgYB","range":"Form_range__1R4hK","name":"Form_name__2yu2C","actions":"Form_actions__2CvYv"};